if (!customElements.get('product-card-variants')) {
  class ProductCardVariants extends HTMLElement {
    constructor() {
      super();

      this.colors = this.querySelectorAll('[data-product-card-hover-init]');
      this.colors.forEach((color) => {
        color.addEventListener('mouseover', this.updateProductCard.bind(this));
      });
    }

    updateProductCard(event) {
      let target = event.target;

      if (typeof target.dataset.productCardHoverImage === 'undefined') {
        target = event.target.closest('[data-product-card-hover-image]');
      }

      let image = target.dataset.productCardHoverImage;
      let url = target.dataset.productCardHoverUrl;
      let price = target.dataset.productCardHoverPrice;

      let parent = target.closest('[data-product-card-hover]');
      let images = parent.querySelector('[data-card-hover-image]').querySelectorAll('img');
      let variantImage = document.createElement('img');
      variantImage.setAttribute('src', image);

      variantImage.classList.add(
        'product-card__image--primary',
        'object-contain',
        'mb-0',
        'block',
        'relative',
        'z-10'
      );

      if (typeof target.dataset.cardHoverImageRotate !== 'undefined') {
        variantImage.classList.add('rotate-[270deg]');
      }
      variantImage.style.aspectRatio = '3/4';

      images.forEach((image) => {
        image.remove();
        // image.classList.add('opacity-0');
        // image.classList.remove('relative');
        // image.classList.add('absolute');
      });
      parent.querySelector('[data-card-hover-image]').appendChild(variantImage);
      parent.querySelector('[data-card-hover-price] .price__item--regular').innerText = price;
      parent.querySelector('[data-card-hover-image]').href = url;
    }
  }

  window.ProductCardVariants = ProductCardVariants;

  customElements.define('product-card-variants', ProductCardVariants);
}
